import store from "@/store";
import NProgress from "nprogress";
import "../node_modules/nprogress/nprogress.css";
NProgress.configure({ showSpinner: false });

store.watch(
  state => state.loadingStore.loading,
  (newVal, oldVal) => {
    if (newVal === 0) return NProgress.done();
    if (oldVal === 0) return NProgress.start();
    NProgress.set(1.8 / Math.max(oldVal, newVal));
  }
);
